import './Header.scss';
import { useState, useEffect } from 'react';

const Header = () => {

    const [sticky, setSticky] = useState("");

    // Sticky Area
    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    }, []);

    
    /* Method that will fix header after a specific scrollable */
    const isSticky = (e) => {
        const scrollTop = window.scrollY;
        const stickyClass = scrollTop >= 250 ? 'is-sticky' : '';
        setSticky(stickyClass);
    };

    return (
        <div className='notification--header-wrapper'>
            <div className='notification--header-top'>
                <img key='company-logo' src="/images/logo.png" style={{ width: '40px', height: '40px', marginRight: '16px' }} alt="logo" />
                Maventech Labs Pvt Ltd
            </div>
            <div className={`notification--header-fixed ${sticky}`}>
                <div className='notification--header-bottom'>
                    Vehicle Service Maintenance
                </div>
            </div>
        </div>
    )
}

export default Header